
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M484.102 263.836l4.8-7.836-4.8-7.84c-.805-1.308-20.118-32.48-57.637-63.719-49.903-41.543-108.692-63.504-170.016-63.504-61.308 0-120.242 21.95-170.43 63.473-37.734 31.223-57.265 62.371-58.078 63.684L23.04 256l4.902 7.906c.813 1.313 20.344 32.461 58.079 63.684 50.187 41.523 109.12 63.472 170.43 63.472 61.323 0 120.112-21.96 170.015-63.503 37.52-31.239 56.832-62.41 57.637-63.723zm-77.63 41.324c-44.89 37.094-95.367 55.899-150.023 55.899-54.676 0-105.316-18.817-150.511-55.934C82.563 285.93 66.715 266.492 58.953 256c7.766-10.5 23.613-29.934 46.985-49.129 45.195-37.113 95.832-55.934 150.511-55.934 54.656 0 105.13 18.81 150.024 55.899 23.27 19.226 38.98 38.691 46.636 49.164-7.664 10.477-23.37 29.941-46.636 49.16zm0 0"}}),_c('path',{attrs:{"d":"M256 165.867c-49.7 0-90.133 40.434-90.133 90.133s40.434 90.133 90.133 90.133 90.133-40.434 90.133-90.133-40.434-90.133-90.133-90.133zm0 150.266c-33.156 0-60.133-26.977-60.133-60.133s26.977-60.133 60.133-60.133 60.133 26.977 60.133 60.133-26.977 60.133-60.133 60.133zm0 0M30 30h62.625V0H0v91.5h30zm0 0M419.375 0v30H482v61.5h30V0zm0 0M30 420.5H0V512h92.625v-30H30zm0 0M482 482h-62.625v30H512v-91.5h-30zm0 0"}})])
          )
        }
      }
    